/* eslint-disable camelcase */
import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import algoliasearch from 'algoliasearch/lite'
import Typography from '@material-ui/core/Typography'
import Grid from '@material-ui/core/Grid'
import EventsSlider from '../coach-offering-group-events/group-events-slider'
import useStyles from './coach-offering-programs.styles'
import ProgramCardAlgolia from './program-card'

const searchClient = algoliasearch(process.env.ALGOLIA_APP_ID, process.env.ALGOLIA_API_KEY)
const index = searchClient.initIndex(process.env.ALGOLIA_GROUP_EVENTS_INDEX_NAME)

const getPrograms = async (query, setPrograms) => {
  const { hits } = await index.search('', {
    filters: query,
    hitsPerPage: 100,
  })
  setPrograms(hits)
}

function CoachOfferingPrograms({ coach }) {
  const [programs, setPrograms] = useState([])
  const classes = useStyles()

  const algoliaTimestamp = (date = new Date()) => Math.floor(date / 1000)
  const coachId = coach?.coach?.id
  const query = coachId
    ? `coach_id:${coachId} AND (tags:"PGA Jr. League" OR tags:"PGA Family Cup") AND registration_close_date_time_ts > ${algoliaTimestamp()}`
    : null

  useEffect(() => {
    if (query) {
      getPrograms(query, setPrograms)
    }
  }, [query])

  if (!coach || !coach.coach) {
    return null
  }

  return programs.length > 0 ? (
    <Grid
      className={classes.offeringsRoot}
      container
      xs={11}
      md={11}
      lg={9}
    >
      <Grid item xs={12}>
        <Typography
          variant="overline"
          className={classes.offeringsOverline}
        >
          Hosted by {coach.firstName}
        </Typography>
      </Grid>
      <Grid item xs={12}>
        <Typography variant="h4">
          Join a Program
        </Typography>
      </Grid>
      <Grid item xs={12}>
        <EventsSlider
          events={programs}
          renderEvent={
            (event) => <ProgramCardAlgolia key={event.id} event={event} />
          }
        />
      </Grid>
    </Grid>
  ) : null
}

CoachOfferingPrograms.propTypes = {
  coach: PropTypes.shape({
    coach: PropTypes.shape({
      id: PropTypes.string,
    }),
    firstName: PropTypes.string,
  }),
}

export default CoachOfferingPrograms
